/* @flow */

import React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';

type Props = {
  classes: Object,
  className?: string,
  scheme?: 'light' | 'dark',
  kind?: 'bouncy' | 'scaley',
};

type State = {};


class BouncyLoader extends React.Component {
  props: Props;
  state: State = {};

  static defaultProps = {
    className: undefined,
    scheme: 'light',
    kind: 'scaley',
  };

  render() {
    const {
      classes,
      className,
      scheme,
      sheet,
      kind,
      ...otherProps
    } = this.props;
    return (
      <div {...otherProps} className={classNames(classes.loader, className)}>
        <div className={classNames(classes.dots, kind, scheme)}>
          <div />
          <div />
          <div />
        </div>
      </div>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    loader: {
      textAlign: 'center',
      width: '100%',
      paddingBottom: '33%',
      position: 'relative',
    },
    dots: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      '& >*': {
        flex: 1,
        borderRadius: '100%',
        '&:not(:last-child)': {
          marginRight: 1,
        },
      },
      '&.bouncy >*': {
        animation: 'bouncy 0.9s infinite alternate',
        '&:nth-of-type(2)': {
          animationDelay: '0.3s',
        },
        '&:nth-of-type(3)': {
          animationDelay: '0.6s',
        },
      },
      '&.scaley >*': {
        animation: 'bounceScale 1.4s infinite ease-in-out both',
        '&:nth-of-type(1)': {
          animationDelay: '-0.32s',
        },
        '&:nth-of-type(2)': {
          animationDelay: '-0.16s',
        },
      },
      '&.light >*': {
        backgroundColor: theme.color.white,
      },
      '&.dark >*': {
        backgroundColor: theme.color.basis2,
      },
    },
    '@keyframes bouncy': {
      '0%': {
        transform: 'translateY(0)',
      },
      '100%': {
        transform: 'translateY(-5px)',
      },
    },
    '@keyframes bounceScale': {
      '0%, 80%, 100%': {
        transform: 'scale(0)',
      },
      '40%': {
        transform: 'scale(1.0)',
      },
    },
  };
}

export default useSheet(applyStyles)(BouncyLoader);
